const { onlyAlphaNumeric, SPACE } = require('../helpers');

const regEx = /^CP[0-9]{4}$/;
exports.zipCodeNormalize = (zipCode) => {
  if (!zipCode) {
    return zipCode;
  }
  const zip = onlyAlphaNumeric(zipCode);
  if (zipCode.length <= 2) {
    return zip;
  }
  return `${zip.slice(0, 2).toUpperCase()} ${zip.slice(2, 6)}`;
};

exports.countryDefinition = {
  country: 'El Salvador',
  code: 'SV',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    address2: { label: 'Address 2' },
    city: { label: 'Town', width: 0.5 },
    stateCode: { label: 'Department' },
    zipCode: {
      label: 'Postcode',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', SPACE, 'city'],
    ['stateCode']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', 'city'],
    ['stateCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    { field: 'stateCode' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(regEx),
      error: 'Must be 4 numbers preceded by CP, CP 1120'
    }
  ]
};
